export var PatSnapAvatar;
(function (PatSnapAvatar) {
    function convertAvatar(avatar) {
        return {
            color: `#${Number(avatar.avatar_color).toString(16)}`,
            url: avatar.avatar_value || avatar.avatar,
            firstChar: avatar.avatar_pattern,
        };
    }
    PatSnapAvatar.convertAvatar = convertAvatar;
})(PatSnapAvatar || (PatSnapAvatar = {}));
